// extracted by mini-css-extract-plugin
module.exports = {"floor":"hall_floor__1ycQY","lateralMenu":"hall_lateralMenu__2pRmG"};